<template>
  <div class="d-flex flex-column align-center">
    <h6 class="text-h6 font-weight-bold my-3 text-uppercase grey--text text--darken-1">
      {{ contactUsText }}
    </h6>
    <h1 class="text-h1 font-weight-regular my-3">
      {{ headerCopy }}
    </h1>
    <p class="my-5 grey--text text--darken-1">
      {{ helperTextCopy }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ContactUsHeader',
  props: {
    contactUsText: {
      type: String,
      required: true
    },
    practiceName: {
      type: String,
      default: null
    }
  },
  computed: {
    headerCopy () {
      return this.practiceName ? `Send A Message To ${this.practiceName}` : 'Send Us A Message'
    },
    helperTextCopy () {
      const contactText = this.practiceName ? ` regarding ${this.practiceName}` : ''
      return `If you have any questions, concerns, or comments${contactText}, please fill out the short contact form below.`
    }
  }
}
</script>
